import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PhoneNumbersService {
  constructor(private http: HttpClient) {}

  save(projectId, body) {
    return this.http.post(`/projects/${projectId}/numbers`, body);
  }

  addPhoneNumber(projectId, msisdnIds: number) {
    return this.http.post(`/projects/${projectId}/attach`, [msisdnIds]);
  }

  removePhoneNumber(projectId, msisdnIds: number) {
    return this.http.post(`/projects/${projectId}/detach`, {
      msisdnId: msisdnIds,
      projectId: projectId
    });
  }
}
